import { createApp } from "vue";
import PrimeVue from "primevue/config";
import Contact from "./Contact.vue";

import TJButton from "@components/TJButton.vue";

// Only loaded on the Contact template, but guard in case the element is missing
const mountElement = document.getElementById("contact-form");

if (mountElement) {
  const app = createApp(Contact);

  app.component("TJButton", TJButton);
  app.component("Btn", TJButton);

  app.use(PrimeVue);

  app.mount(mountElement);
}
